export default "__VITE_ASSET__NHWk39Hh__"